import { render, staticRenderFns } from "./mFloatingBetCart.vue?vue&type=template&id=0fd4ddfd&scoped=true"
import script from "./mFloatingBetCart.vue?vue&type=script&lang=js"
export * from "./mFloatingBetCart.vue?vue&type=script&lang=js"
import style0 from "./mFloatingBetCart.vue?vue&type=style&index=0&id=0fd4ddfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd4ddfd",
  null
  
)

export default component.exports